import React, { Component } from "react";

import db from "../../services/query";

import lbl from "../../data/Labels.json";

import CardItems from "./CardItems";

import ListStats from "../common/ListStats";
import MainTitle from "../common/MainTitle";

class Results extends Component {
  state = { data: [] };

  componentDidMount = async () => {
    await db.getAll("results").then(({ data }) => {
      this.setState({ data });
    });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    return this.state.data != nextState.data;
  };

  render() {
    const { data } = this.state;

    return (
      <div className="main-content">
        <div className="main-content-header">
          <div className="right-content">
            <MainTitle title={lbl.Faculties} />
          </div>
        </div>
        <div className="main-content-body">
          <ListStats stats={data.summary} />
          <CardItems cards={data.data} />
        </div>
      </div>
    );
  }
}

export default Results;
